<template>
  <div class="statusGroup-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick"></Menus>

    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popUpTitle"
      @save="saveStatusCode"
      :requiredError="entryError"
      :errorMessages="errorMessage"
      :viewMode="viewMode"
      @requiredClicked="errorMessageClicked"
      :successMessages="successMessages"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
    >
      <Input
        placeholder="Status Code"
        :isDisabled="disableStatusCode"
        :inputValue.sync="statusCode"
        :isRequired="true"
        ref="statusCode"
        :errorMessage.sync="statusCodeError"
        validator="text,5,uppercase,alphanumeric,none"
        @focusChanged="onStatusCodeFocusChanged"
      />

      <Input
        placeholder="Status Description"
        :isDisabled="disableStatusDesc"
        :inputValue.sync="statusDesc"
        :isRequired="true"
        ref="statusDesc"
        :errorMessage.sync="statusDescError"
        validator="text,100,,alphanumeric,all"
      />
      <InputQuery
        placeholder="Status Group"
        :isDisabled="disableStatusGroup"
        :items="statusGroupList"
        itemKey="Status Group"
        descKey="Group Name"
        :isRequired="true"
        :errorMessage.sync="statusGroupError"
        :selectedObject.sync="selectedStatusGroup"
      />

      <Input
        placeholder="Pending Message"
        :isDisabled="disablePendingMsg"
        :inputValue.sync="pendingMsg"
        :isRequired="false"
        ref="pendingMessage"
        :errorMessage.sync="pendingMsgError"
        validator="text,100,,alphanumeric,all"
      />

      <InputQuery
        placeholder="Next Action"
        :isDisabled="disableNextAction"
        :items="statusCodeList"
        itemKey="Status"
        descKey="Status Desc"
        :isRequired="false"
        :selectedObject.sync="selectedNextAction"
      />

      <BoxContainer
        style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
        title="Option"
      >
        <div class="columns" style="display: flex; flex-direction: column">
          <CheckBoxV2
            :isDisabled="disableCustUpdate"
            title="Allow Customer update(web)"
            :isChecked.sync="custUpdate"
            style="padding-bottom: 10px"
          />
          <CheckBoxV2
            :isDisabled="disableStatusView"
            title="Internal View Only"
            :isChecked.sync="statusView"
            style="padding-bottom: 10px"
          />
          <CheckBoxV2
            :isDisabled="disableShowRemark"
            title="Show remarks on report"
            :isChecked.sync="showRemark"
            style="padding-bottom: 10px"
          />
          <CheckBoxV2
            :isDisabled="disableIsService"
            title="Status is a service"
            :isChecked.sync="isService"
            style="padding-bottom: 10px"
          />
        </div>
        <div class="columns" style="display: flex; flex-direction: column">
          <CheckBoxV2
            :isDisabled="disableUpdateByCont"
            title="Update by Container"
            :isChecked.sync="updateByCont"
            style="padding-bottom: 10px"
          />
          <CheckBoxV2
            :isDisabled="disableDocUpdate"
            title="Requires Document Fields Update"
            :isChecked.sync="docUpdate"
            style="padding-bottom: 10px"
          />
          <CheckBoxV2
            :isDisabled="disableAmountUpdate"
            title="Requires Amount Update"
            :isChecked.sync="amountUpdate"
            style="padding-bottom: 10px"
          />
          <CheckBoxV2
            :isDisabled="disableShowIndicator"
            title="Show Indicator"
            :isChecked.sync="showIndicator"
            style="padding-bottom: 10px"
          />
        </div>

        <div class="columns" style="display: flex; flex-direction: column">
          <CheckBoxV2
            :isDisabled="disableTriggerUpload"
            title="Trigger Upload to Customer"
            :isChecked.sync="triggerUpload"
            style="padding-bottom: 10px"
          />
        </div>
      </BoxContainer>

      <RadioButtonSet
        title="Update Type"
        :buttons="updateTypeList"
        labelKey="label"
        :selected.sync="selectedUpdateType"
        :isDisabled="disableUpdateType"
        :isHorizontal="true"
      />

      <div class="flex-row" style="margin-top: 10px; display: flex">
        <Dropdown
          placeholder="Document Type"
          :items="docTypeList"
          itemKey="Description"
          :selectedObject.sync="selectedDocType"
          :search.sync="selectedSearchDocType"
          :errorMessage.sync="docTypeError"
          ref="docType"
          :isDisabled="disableDocType"
          :isRequired="false"
          style="padding-right: 10px"
        />
        <InputQuery
          placeholder="Document Code"
          :items="docCodeList"
          itemKey="Doc Code"
          descKey="Description"
          :isDisabled="disableDocCode"
          :isRequired="false"
          :selectedObject.sync="selectedDocCode"
        />
      </div>

      <div class="flex-row" style="display: flex">
        <Input
          placeholder="Duration"
          :isDisabled="disableDuration"
          :inputValue.sync="duration"
          :isRequired="false"
          :errorMessage.sync="durationError"
          ref="duration"
          validator="integer,9,uppercase,alphanumeric,all"
          style="padding-right: 10px"
        />
        <Dropdown
          placeholder="Duration Type"
          :items="durationTypeList"
          itemKey="label"
          :selectedObject.sync="selectedDurationType"
          :search.sync="selectedSearchDurationType"
          ref="durationType"
          :errorMessage.sync="durationTypeError"
          :isDisabled="disableDurationType"
        />
      </div>
      <Input
        placeholder="Quantity UOM"
        :isDisabled="disableQuantityUOM"
        :inputValue.sync="quantityUOM"
        :isRequired="false"
        ref="Quantity UOM"
        :errorMessage.sync="quantityUOMError"
        validator="text,10,uppercase,alphanumeric,all"
      />
      <InputQuery
        placeholder="Charges Code"
        :isDisabled="disableChargesCode"
        :items="chargesCodeList"
        itemKey="Charge Code"
        descKey="Description"
        :selectedObject.sync="selectedChargesCode"
      />
      <Input
        placeholder="Unit Price"
        :isDisabled="disableUnitPrice"
        :inputValue.sync="unitPrice"
        :isRequired="false"
        ref="Unit Price"
        :errorMessage.sync="unitPriceError"
        validator="positiveDecimal,6,2"
      />
    </PopupEntry>
    <div class="right-container">
      <TableBox
        title="Status Code"
        :tableData="statusCodeList"
        :selectedRow.sync="selectedStatusCode"
        :hideColumns="['Status View', 'Sys Update Only']"
      ></TableBox>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      menus: [
        {
          title: 'New Status Code',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: false,
        },
        {
          title: 'Edit Status Code',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: false,
        },
        {
          title: 'Delete Status Code',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: false,
        },
        {
          title: 'View Status Code',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: false,
        },
      ],
      updateTypeList: [
        { label: 'Only by DSM Application', keyValue: '0' },
        { label: 'Manual by User', keyValue: '2' },
        { label: 'Both', keyValue: '1' },
      ],
      durationTypeList: [
        { label: 'Weeks', keyValue: 'W' },
        { label: 'Days', keyValue: 'D' },
        { label: 'Hours', keyValue: 'H' },
        { label: 'Minutes', keyValue: 'M' },
      ],

      //Table
      statusCodeList: [],
      selectedStatusCode: [],
      statusGroupList: [],
      selectedStatusGroup: [],
      selectedNextAction: [],
      docCodeList: [],
      chargesCodeList: [],
      selectedChargesCode: [],

      updatedStatusCode: '', // Will store the status code to prevent the system from repeatedly appending suffix when the user re-selects the status code input.

      //Data
      statusSuffix: 'Z',
      statusCode: '',
      statusDesc: '',
      pendingMsg: '',
      duration: '',
      quantityUOM: '',
      unitPrice: '',

      custUpdate: false,
      updateByCont: false,
      triggerUpload: false,
      statusView: false,
      docUpdate: false,
      showRemark: false,
      amountUpdate: false,
      isService: false,
      showIndicator: false,

      selectedSearchDurationType: '',
      selectedSearchDocType: '',
      selectedDurationType: null,
      selectedDocType: null,
      selectedUpdateType: null,
      selectedDocCode: null,

      isAdmin: false,

      // Pop up box setting
      popupEntryShow: false,
      popUpTitle: '',
      entryError: [],
      errorMessage: [],
      successMessages: [],
      saveOption: '',
      createdBy: '',
      updatedBy: '',
      disableStatusCode: false,
      disableStatusDesc: false,
      disableStatusGroup: false,
      disablePendingMsg: false,
      disableNextAction: false,
      disableCustUpdate: false,
      disableUpdateByCont: false,
      disableTriggerUpload: false,
      disableStatusView: false,
      disableDocUpdate: false,
      disableShowRemark: false,
      disableAmountUpdate: false,
      disableIsService: false,
      disableShowIndicator: false,
      disableUpdateType: false,
      disableDocType: false,
      disableDocCode: false,
      disableDuration: false,
      disableDurationType: false,
      disableQuantityUOM: false,
      disableChargesCode: false,
      disableUnitPrice: false,

      //Error Message
      statusCodeError: '',
      statusDescError: '',
      statusGroupError: '',
      pendingMsgError: '',
      durationError: '',
      durationTypeError: '',
      docTypeError: '',
      quantityUOMError: '',
      unitPriceError: '',
    };
  },

  methods: {
    disableEntry: function () {
      this.disableStatusCode = true;
      this.disableStatusDesc = true;
      this.disableStatusGroup = true;
      this.disablePendingMsg = true;
      this.disableNextAction = true;
      this.disableCustUpdate = true;
      this.disableUpdateByCont = true;
      this.disableTriggerUpload = true;
      this.disableStatusView = true;
      this.disableDocUpdate = true;
      this.disableShowRemark = true;
      this.disableAmountUpdate = true;
      this.disableIsService = true;
      this.disableShowIndicator = true;
      this.disableUpdateType = true;
      this.disableDocType = true;
      this.disableDocCode = true;
      this.disableDuration = true;
      this.disableDurationType = true;
      this.disableQuantityUOM = true;
      this.disableChargesCode = true;
      this.disableUnitPrice = true;
    },
    enableEntry: function () {
      this.disableStatusCode = false;
      this.disableStatusDesc = false;
      this.disableStatusGroup = false;
      this.disablePendingMsg = false;
      this.disableNextAction = false;
      this.disableCustUpdate = false;
      this.disableUpdateByCont = false;
      this.disableTriggerUpload = false;
      this.disableStatusView = false;
      this.disableDocUpdate = false;
      this.disableShowRemark = false;
      this.disableAmountUpdate = false;
      this.disableIsService = false;
      this.disableShowIndicator = false;
      this.disableUpdateType = false;
      this.disableDocType = false;
      this.disableDocCode = false;
      this.disableDuration = false;
      this.disableDurationType = false;
      this.disableQuantityUOM = false;
      this.disableChargesCode = false;
      this.disableUnitPrice = false;
    },
    initializeData: function () {
      this.duration = '0';
      this.unitPrice = '0.00';
      this.selectedDurationType = this.durationTypeList[0];
      this.selectedUpdateType = this.updateTypeList[2];
    },
    errorMessageClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },

    getSpecificGroup: async function (record) {
      this.$fullscreenLoading('Getting Details');
      const details = (
        await this.$apiCallV2(`/Master/GetDetailsMaster`, {
          masterfile: 'STATUSTASKCODE',
          recordid: record,
        })
      )['StatusTaskCode'];
      this.statusCode = details['Status'];
      this.statusDesc = details['StatusDescription'];
      this.selectedStatusGroup = this.statusGroupList.getSelected(details['StatusGroup'], 'Status Group');
      this.pendingMsg = details['PendingMsg'];
      this.selectedNextAction = this.statusCodeList.getSelected(details['NextAction'], 'Status');

      this.custUpdate = details['CustUpdate'] == '1';
      this.updateByCont = details['UpdateByCont'] == '1';
      this.triggerUpload = details['TriggerUpload'] == 'Y';
      this.statusView = details['StatusView'] == '0';
      this.docUpdate = details['DocUpdate'] == '1';
      this.showRemark = details['ShowRemark'] == '1';
      this.amountUpdate = details['AmountUpdate'] == '1';
      this.isService = details['IsService'] == '1';
      this.showIndicator = details['ShowIndicator'] == '1';

      this.selectedUpdateType = this.updateTypeList.getSelected(details['Type'], 'keyValue');
      this.selectedDocType = this.docTypeList.getSelected(details['Doc_type'], 'Doc Type');
      this.selectedDocCode = this.docCodeList.getSelected(details['Doc_code'], 'Doc Code');
      this.duration = details['Duration'];
      this.selectedDurationType = this.durationTypeList.getSelected(details['DurationType'], 'keyValue');
      this.quantityUOM = details['QtyUOM'];
      this.selectedChargesCode = this.chargesCodeList.getSelected(details['TxnChargeCode'], 'Charge Code');
      this.unitPrice = details['UnitPrice'];
      this.createdBy = `${details['UserID'] || ''} ${
        details['DateCreated'] ? new Date(details['DateCreated']).formatString('dd/MM/yyyy HH:mm') : ''
      }`;
      this.updatedBy = `${details['UserID'] || ''} ${
        details['DateUpdated'] ? new Date(details['DateUpdated']).formatString('dd/MM/yyyy HH:mm') : ''
      }`;

      this.$fullscreenLoading();
    },

    checkFields: function () {
      if (!this.statusCode || this.statusCode.trim().length == 0) {
        this.statusCodeError = 'Status Code is Required !';
        this.entryError.push({
          key: 'statusCode',
          value: this.statusCodeError,
        });
      }

      if (this.statusCode.trim().length > 5) {
        this.statusCodeError = 'Status Code  cannot exceed 5 characters !';
        this.entryError.push({
          key: 'statusCode',
          value: this.statusCodeError,
        });
      }

      if (!this.statusDesc || this.statusDesc.trim().length == 0) {
        this.statusDescError = 'Status Description is Required !';
        this.entryError.push({
          key: 'statusDesc',
          value: this.statusDescError,
        });
      }

      if (this.statusDesc.trim().length > 100) {
        this.statusDescError = 'Status Description cannot exceed 100 characters !';
        this.entryError.push({
          key: 'statusDesc',
          value: this.statusDescError,
        });
      }

      if (this.selectedStatusGroup === null) {
        this.statusGroupError = 'Status Group cannot be empty !';
        this.entryError.push({
          key: 'statusGroup',
          value: this.statusGroupError,
        });
      }

      if (this.pendingMsg && this.pendingMsg.trim().length > 100) {
        this.pendingMsgError = 'Pending Message cannot exceed 100 characters !';
        this.entryError.push({
          key: 'pendingMessage',
          value: this.pendingMsgError,
        });
      }

      if (this.duration && this.duration.trim().length > 10) {
        this.durationError = 'Duration cannot exceed 10 characters !';
        this.entryError.push({
          key: 'duration',
          value: this.durationError,
        });
      }

      if (this.quantityUOM && this.quantityUOM.trim().length > 10) {
        this.quantityUOMError = 'Quantity UOM cannot exceed 10 characters !';
        this.entryError.push({
          key: 'Quantity UOM',
          value: this.quantityUOMError,
        });
      }

      if (this.unitPrice) {
        const [whole, decimal] = this.unitPrice.split('.');
        if (whole.length > 6) {
          this.unitPriceError = 'The Unit Price cannot exceed 6 whole digits and 2 decimals !';
          this.entryError.push({
            key: 'Unit Price',
            value: this.unitPriceError,
          });
        } else if (decimal && decimal.length > 2) {
          this.unitPriceError = 'The Unit Price cannot exceed 6 whole digits and 2 decimals !';
          this.entryError.push({
            key: 'Unit Price',
            value: this.unitPriceError,
          });
        }
      }

      if (!this.selectedDocType && this.selectedSearchDocType) {
        this.docTypeError = 'Invalid Document Type!';
        this.entryError.push({
          key: 'docType',
          value: this.docTypeError,
        });
      }

      if (!this.selectedDurationType && this.selectedSearchDurationType) {
        this.durationTypeError = 'Invalid Duration Type!';
        this.entryError.push({
          key: 'durationType',
          value: this.durationTypeError,
        });
      }

      return this.entryError.length == 0;
    },
    clearInputFields: function () {
      this.statusCode = '';
      this.statusDesc = '';
      this.selectedStatusGroup = null;
      this.pendingMsg = '';
      this.selectedNextAction = null;

      this.custUpdate = false;
      this.updateByCont = false;
      this.triggerUpload = false;
      this.statusView = false;
      this.docUpdate = false;
      this.showRemark = false;
      this.amountUpdate = false;
      this.isService = false;
      this.showIndicator = false;
      this.selectedUpdateType = null;
      this.selectedDocType = null;
      this.selectedSearchDocType = '';
      this.selectedDocCode = null;
      this.duration = '';
      this.selectedDurationType = null;
      this.selectedSearchDurationType = '';
      this.quantityUOM = '';
      this.selectedChargesCode = null;
      this.unitPrice = '';
      this.updatedBy = '';
      this.createdBy = '';
    },
    clearErrorMessages: function () {
      this.statusCodeError = '';
      this.statusDescError = '';
      this.statusGroupError = '';
      this.docTypeError = '';
      this.durationTypeError = '';
    },

    saveStatusCode: async function () {
      this.entryError = [];
      this.errorMessage = [];
      const isValid = this.checkFields();
      const statusCodeTrimmed = this.statusCode.trim();
      const pendingMsgTrimmed = this.pendingMsg.trim();
      const statusDescTrimmed = this.statusDesc.trim();
      if (isValid) {
        const dataToPost = {
          status: statusCodeTrimmed,
          action: this.saveOption,
          statusdescription: statusDescTrimmed,
          statusgroup: this.selectedStatusGroup['Status Group'],
          pendingmsg: pendingMsgTrimmed,
          nextaction: this.selectedNextAction ? this.selectedNextAction['Status'] : '',
          indicator: 'N',
          type: this.selectedUpdateType['keyValue'],
          custupdate: this.custUpdate ? 1 : 0,
          updatebycont: this.updateByCont ? 1 : 0,
          triggerupload: this.triggerUpload ? 'Y' : 'N',
          statusview: this.statusView ? 0 : 1,
          docupdate: this.docUpdate ? 1 : 0,
          showremark: this.showRemark ? 1 : 0,
          amountupdate: this.amountUpdate ? 1 : 0,
          isservice: this.isService ? 1 : 0,
          showindicator: this.showIndicator ? 1 : 0,
          doctype: this.selectedDocType ? this.selectedDocType['Doc Type'] : '',
          doccode: this.selectedDocCode ? this.selectedDocCode['Doc Code'] : '',
          duration: this.duration,
          durationtype: this.selectedDurationType ? this.selectedDurationType['keyValue'] : '',
          qtyuom: this.quantityUOM,
          txnchargecode: this.selectedChargesCode ? this.selectedChargesCode['Charge Code'] : '',
          unitprice: this.unitPrice,
        };

        this.$fullscreenLoading('Saving Status Code');
        const postUpdate = await this.$apiCallV2('/StatusCode/SaveStatusTaskCode', dataToPost);
        this.$fullscreenLoading();
        if (postUpdate[0].Results >= 1) {
          this.errorMessage.push(postUpdate[0].ErrMsg);
        } else {
          if (this.saveOption == 'N') {
            this.successMessages.push('Successfully created Status Code : ' + this.statusCode);
          }
          if (this.saveOption == 'E') {
            this.successMessages.push('Successfully edited Status Code : ' + this.statusCode);
          }
          this.viewMode = true;
          this.disableEntry();
          this.popUpTitle = 'View Status Code';
          this.getSpecificGroup(this.statusCode);
          this.getStatusCodeList();
        }
      }
    },
    handleMenuClick: async function (menu) {
      this.errorMessage = [];
      this.entryError = [];
      this.successMessages = [];
      this.clearErrorMessages();

      switch (menu.title) {
        case 'View Status Code':
          if (this.selectedStatusCode.length == 0) {
            this.$showAlert('error', 'No Status Code Selected', 'Please select a record to view');
          } else {
            await this.getSpecificGroup(this.selectedStatusCode[0]['Status']);
            this.disableEntry();
            this.viewMode = true;
            this.popUpTitle = 'View Status Code';
            this.popupEntryShow = true;
          }
          break;
        case 'Edit Status Code':
          if (this.selectedStatusCode.length == 0) {
            this.$showAlert('error', 'No Status Code Selected', 'Please select a record to edit');
          } else {
            await this.getSpecificGroup(this.selectedStatusCode[0]['Status']);
            this.enableEntry();
            this.saveOption = 'E';
            this.disableStatusCode = true;
            this.viewMode = false;
            this.popUpTitle = 'Edit Status Code';
            this.popupEntryShow = true;
            this.$nextTick(() => {
              this.$refs['statusDesc'].setFocus();
            });
          }
          break;
        case 'New Status Code':
          this.clearInputFields();
          this.enableEntry();
          this.initializeData();
          this.saveOption = 'N';
          this.viewMode = false;
          this.popUpTitle = 'New Status Code';
          this.popupEntryShow = true;
          this.isFocusChanged = true;
          this.$nextTick(() => {
            this.$refs['statusCode'].setFocus();
          });
          break;
        case 'Delete Status Code':
          if (this.selectedStatusCode.length == 0) {
            this.$showAlert('error', 'No Status Code Selected', 'Please select a record to delete');
            return;
          }
          {
            const deleting = await this.$showAlert(
              'warning',
              'Delete Status Code',
              `Are you sure you want to delete Status Code ${this.selectedStatusCode[0]['Status']} ?`,
              [
                { text: 'Delete', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );

            if (deleting == 'Cancel') {
              return;
            }

            this.$fullscreenLoading('Deleting Status Code');
            const result = await this.$apiCallV2('/StatusCode/SaveStatusTaskCode', {
              action: 'D',
              status: this.selectedStatusCode[0]['Status'],
            });
            this.$fullscreenLoading();
            if (result[0]['Results'] == 0) {
              this.$showAlert(
                'success',
                'Status Code Deleted',
                `Successfully deleted Status Code ${this.selectedStatusCode[0]['Status']}`,
              );
              this.$nextTick(async () => await this.getStatusCodeList());
              this.selectedStatusCode = [];
              return;
            }
            this.$showAlert('error', 'Status Code Not Deleted', `${result[0]['ErrMsg']}`);
          }
          break;
      }
    },
    onStatusCodeFocusChanged: async function (focusedIn) {
      if (!focusedIn) {
        if (!this.isAdmin && this.statusCode) {
          // A suffix will always be added to the status code if it is created by a normal user, even if the last character of the status code is the same as the suffix.
          // To prevent the suffix from being repeatedly appended if the user clicks again, a check is added to ensure the status code is not the same as the updatedStatusCode.
          if (this.statusCode.trim().length <= 4 && this.statusCode.trim() != this.updatedStatusCode) {
            await this.$showAlert(
              'info',
              `A suffix '${this.statusSuffix}' will be added at the back by the system if it is a new Status Code.`,
              '    ',
            );
            this.statusCode = this.statusCode + this.statusSuffix;
            this.updatedStatusCode = this.statusCode;
            this.$nextTick(() => {
              this.$refs['statusDesc'].setFocus();
            });
          } else if (this.statusCode.trim() != this.updatedStatusCode && this.statusCode.trim().length === 5) {
            await this.$showAlert('error', `Please use a 4 characters Status Code`, '   ');
            this.$nextTick(() => {
              this.$refs['statusCode'].setFocus();
            });
          }
        }
      }
    },

    getStatusCodeList: async function () {
      this.statusCodeList = [];
      this.statusCodeList = await this.$apiCallV2(`/master/GetListMaster`, {
        masterfile: 'STATUS',
      });
    },
  },
  mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Status Code') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });

    const mountedPromises = [];
    let promisesFulfilled = 0;
    mountedPromises.push(
      this.$apiCallV2(`/master/GetListMaster`, { masterfile: 'STATUS' }).then((result) => {
        this.statusCodeList = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2(`/master/GetListMaster`, {
        masterfile: 'STATUSGROUP',
      }).then((result) => {
        this.statusGroupList = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2(`/master/GetListMaster`, { masterfile: 'DOC' }).then((result) => {
        this.docCodeList = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2(`/master/GetListMaster`, { masterfile: 'DOCTYPE' }).then((result) => {
        this.docTypeList = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2(`/master/GetListMaster`, { masterfile: 'CHARGESCODE' }).then((result) => {
        this.chargesCodeList = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/StatusCode/CheckIsUserDSMAdmin').then((result) => {
        this.isAdmin = result === '1';
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menus = this.menus.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.statusGroup-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}
</style>
